import React from 'react';
import commonUtil from '../../../common/commonUtil';
import "../../../resources/RTCC/css/common/radio_box_style.css";
import { Button } from "../../atoms/RTCC/button";
import { Label } from '../../atoms/RTCC/label';
import './../../../resources/RTCC/css/userInput/userInput.css';

export const GuestConfirmList = (props) => {
    const { state, onClickBack, responsiveFlg } = props;

    const guest = (roomIndex, guestIndex, sumGuests, guestInfo) =>
        <div key={"guest" + guestIndex}>
            <div className="borderWrapper">
                <div style={guestIndex != 0 ? props.borderStyle : { display: "none", margin: "0px auto" }}></div>
            </div>
            <div className="guestInfoWrapper">
                <div className="guestIndexLabelWrapper">
                    <Label label={guestInfo.representFlg ? "代表者" : "同行者" + sumGuests} className="reserveConirmTitle" />
                    <Label
                        label={!guestInfo.representFlg ? guestIndex === 0 ? "(部屋代表者)" : guestInfo.ageGroupFlg == "adult" ? "(大人)" : "(こども)" : ""}
                        className="guestIndexLabel"
                    />
                </div>
                <div className="userInputConfirmWrapper">
                    <div className="userInputConfirm">
                        <ul style={responsiveFlg ? props.ulStyleSp : props.ulStyle}>
                            <li style={responsiveFlg ? props.liStyleSp : props.liStyle}>
                                <Label
                                    label="氏名（漢字）"
                                    className="inputTitleLabel"
                                />
                            </li>
                            <li style={responsiveFlg ? props.liStyleSp : props.liStyle2}>
                                <Label
                                    label={guestInfo.guestName}
                                    className="rtcc_inputContentLabel"
                                />
                            </li>
                            {/* <li style={props.liBtnStyle}>
                                <Button buttonText="変更" className="btnChange" buttonClassName="btnChangeLabel" onClick={onClickBack} />
                            </li> */}
                        </ul>
                    </div>
                    <div className="userInputConfirm">
                        <ul style={responsiveFlg ? props.ulStyleSp : props.ulStyle}>
                            <li style={responsiveFlg ? props.liStyleSp : props.liStyle}>
                                <Label
                                    label="氏名（カナ）"
                                    className="inputTitleLabel"
                                />
                            </li>
                            <li style={responsiveFlg ? props.liStyleSp : props.liStyle2}>
                                <Label
                                    label={guestInfo.guestNameKana}
                                    className="rtcc_inputContentLabel"
                                />
                            </li>
                        </ul>
                    </div>
                    <div className="userInputConfirm">
                        <ul style={responsiveFlg ? props.ulStyleSp : props.ulStyle}>
                            <li style={responsiveFlg ? props.liStyleSp : props.liStyle}>
                                <Label
                                    label="姓（パスポート表記名）"
                                    className="inputTitleLabel"
                                />
                            </li>
                            <li style={responsiveFlg ? props.liStyleSp : props.liStyle2}>
                                <Label
                                    label={guestInfo.guestLastNamePassport}
                                    className="rtcc_inputContentLabel"
                                />
                            </li>
                        </ul>
                    </div>
                    <div className="userInputConfirm">
                        <ul style={responsiveFlg ? props.ulStyleSp : props.ulStyle}>
                            <li style={responsiveFlg ? props.liStyleSp : props.liStyle}>
                                <Label
                                    label="名（パスポート表記名）"
                                    className="inputTitleLabel"
                                />
                            </li>
                            <li style={responsiveFlg ? props.liStyleSp : props.liStyle2}>
                                <Label
                                    label={guestInfo.guestFirstNamePassport}
                                    className="rtcc_inputContentLabel"
                                />
                            </li>
                        </ul>
                    </div>
                    <div className="userInputConfirm">
                        <ul style={responsiveFlg ? props.ulStyleSp : props.ulStyle}>
                            <li style={responsiveFlg ? props.liStyleSp : props.liStyle}>
                                <Label
                                    label="性別"
                                    className="inputTitleLabel"
                                />
                            </li>
                            <li style={responsiveFlg ? props.liStyleSp : props.liStyle2}>
                                <Label
                                    label={props.gender.find(value => value.value == guestInfo.guestGenderId) ?
                                        props.gender.find(value => value.value == guestInfo.guestGenderId).text : ""}
                                    className="rtcc_inputContentLabel"
                                />
                            </li>
                        </ul>
                    </div>
                    <div className="userInputConfirm">
                        <ul style={responsiveFlg ? props.ulStyleSp : props.ulStyle}>
                            <li style={responsiveFlg ? props.liStyleSp : props.liStyle}>
                                <Label
                                    label="生年月日"
                                    className="inputTitleLabel"
                                />
                            </li>
                            <li style={responsiveFlg ? props.liStyleSp : props.liStyle2}>
                                <Label
                                    label={
                                        commonUtil.getDateFromString(guestInfo.guestBirthday, "-").getFullYear() + "年  " +
                                        (commonUtil.getDateFromString(guestInfo.guestBirthday, "-").getMonth() + 1) + "月  " +
                                        commonUtil.getDateFromString(guestInfo.guestBirthday, "-").getDate() + "日"
                                    }
                                    className="rtcc_inputContentLabel"
                                />
                            </li>
                        </ul>
                    </div>
                    <div style={guestInfo.representFlg ? props.borderStyle2 : { display: "none" }}></div>
                    <div className={guestInfo.representFlg ? "userInputConfirm" : "userInputConfirmNone"}>
                        <ul style={responsiveFlg ? props.ulStyleSp : props.ulStyle2}>
                            <li style={responsiveFlg ? props.liStyleSp : props.liStyle}>
                                <Label
                                    label="住所"
                                    className="inputTitleLabel"
                                />
                            </li>
                            <li style={responsiveFlg ? props.liStyleSp : props.liStyle2}>
                                <Label
                                    label={guestInfo.address}
                                    className="rtcc_inputContentLabel"
                                />
                            </li>
                        </ul>
                    </div>
                    <div style={guestInfo.representFlg ? props.borderStyle2 : { display: "none" }}></div>
                    <div className={guestInfo.representFlg ? "userInputConfirm" : "userInputConfirmNone"}>
                        <ul style={responsiveFlg ? props.ulStyleSp : props.ulStyle2}>
                            <li style={responsiveFlg ? props.liStyleSp : props.liStyle}>
                                <Label
                                    label="電話番号"
                                    className="inputTitleLabel"
                                />
                            </li>
                            <li style={responsiveFlg ? props.liStyleSp : props.liStyle2}>
                                <Label
                                    label={guestInfo.telephoneNumber}
                                    className="rtcc_inputContentLabel"
                                />
                            </li>
                        </ul>
                    </div>
                    <div style={guestInfo.representFlg ? props.borderStyle2 : { display: "none" }}></div>
                    <div className={guestInfo.representFlg ? "userInputConfirm" : "userInputConfirmNone"}>
                        <ul style={responsiveFlg ? props.ulStyleSp : props.ulStyle2}>
                            <li style={responsiveFlg ? props.liStyleSp : props.liStyle}>
                                <Label
                                    label="メールアドレス"
                                    className="inputTitleLabel"
                                />
                            </li>
                            <li style={responsiveFlg ? props.liStyleSp : props.liStyle2}>
                                <Label
                                    label={guestInfo.mailAddress}
                                    className="rtcc_inputContentLabel"
                                />
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>;

    const getrooms = () => {
        const room = [];
        let sumGuests = 0;
        props.roomList.map((value, roomIndex) => {
            let guests = [];
            value.guestInfo.map((value, guestIndex) => {
                if (value.representFlg) {
                    guests.push(
                        <div key={"guest" + guestIndex}>
                            {guest(roomIndex, guestIndex, sumGuests, value)}
                        </div>);
                } else {
                    sumGuests += 1;
                    guests.push(
                        <div key={"guest" + guestIndex}>
                            {guest(roomIndex, guestIndex, sumGuests, value)}
                        </div>);
                }
            });
            room.push(
                <div key={"room" + roomIndex}>
                    <div className="roomIndexWrapper">
                        <div className="userInputWrapper4">
                            <Label label={(roomIndex + 1) + "部屋目"} className="roomIndex" />
                        </div>
                    </div>
                    {guests}
                </div>
            );
        })
        return <>{room}</>;
    }
    const rooms = getrooms();

    return (
        <>
            <div>{rooms}</div>
        </>
    );
}

const styles = {
    firstRoomWrapper: {
        width: "80%",
        margin: "0px auto",
        backgroundColor: "#808080",
        padding: "10px 10% 10px 10%",
    },
    guestTitle: {
        display: "flex",
        padding: "10px 0px 15px 0px",
        alignItems: "center",
        whiteSpace: "nowrap"
    },
    guestTitleTopBorder: {
        display: "flex",
        padding: "30px 0px 15px 0px",
        alignItems: "center",
        whiteSpace: "nowrap",
        borderTop: "1px solid #bfbec5",
    },
    userInput: {
        display: "block",
        flexWrap: "wrap",
    },
    roomNum: {
        display: "flex",
        padding: "20px 0px 20px 0px",
        marginBottom: "20px",
        justifyContent: "space-between",
        borderBottom: "1px solid #bfbec5",
    },
    link: {
        display: "inline-block",
        padding: "3px",
        color: "white",
        fontSize: "small",
    },
    bottomLinkArea: {
        marginTop: "30px",
        paddingTop: "40px",
        textAlign: "center",
        borderTop: "1px solid #bfbec5",
    },
    bottomLink: {
        padding: "3px",
        color: "black",
        fontSize: "small",
    },
    breadCrumb
        : {
        display: "flex",
        color: "white",
        marginBottom: "50px",
    },
    breadCrumb2
        : {
        marginBottom: "30px",
    },
    breadCrumbArrow: {
        marginRight: "5px",
        marginLeft: "5px",
        marginTop: "1px",
        fontSize: "small",
    },
    footer: {
        width: "80%",
        padding: "30px 10%",
    },
    genderWrap: {
        marginBottom: "20px",
    },
    gender: {
        display: "flex",
    },
    genderLabel: {
        margin: "0px 30px 0px 10px",
    },
    confirmbox: {
        width: "100%",
        margin: "10px auto",
        display: "flex",
    },
    paymentOption: {
        display: "flex",
        marginTop: "20px",
    },
    fee: {
        display: "flex",
        justifyContent: "space-between",
    },
    pullDownArea: {
        display: "flex",
        alignItems: "center"
    },
    birthDateAreaStyle: {
        padding: "0px 0px 30px 0px",
    },
    reservationInfo: {
        display: "flex",
        justifyContent: "space-between",
        margin: "20px 60px 20px 100px",
    },
}